import audioBufferToWav from "audiobuffer-to-wav"
import blobToAudioBuffer from "./blobToAudioBuffer"

async function mergeAudioBlobs(blobs) {
  const context = new AudioContext()

  const audioBuffers = await Promise.all(blobs.map(blob => blobToAudioBuffer(blob, context)))

  const firstSampleRate = audioBuffers[0].sampleRate
  const firstChannels = audioBuffers[0].numberOfChannels

  if (
    !audioBuffers.every(buffer => buffer.sampleRate === firstSampleRate && buffer.numberOfChannels === firstChannels)
  ) {
    throw new Error("All audio buffers must have the same sample rate and channel count")
  }

  const sampleRate = audioBuffers[0].sampleRate
  const numberOfChannels = audioBuffers[0].numberOfChannels
  const totalLength = audioBuffers.reduce((acc, b) => acc + b.length, 0)

  const outputBuffer = context.createBuffer(numberOfChannels, totalLength, sampleRate)

  let offset = 0
  for (const buffer of audioBuffers) {
    for (let channel = 0; channel < numberOfChannels; channel++) {
      outputBuffer.getChannelData(channel).set(buffer.getChannelData(channel), offset)
    }
    offset += buffer.length
  }

  const wav = audioBufferToWav(outputBuffer)
  return new Blob([wav], { type: "audio/wav" })
}

export default mergeAudioBlobs
